import { render } from "./App.vue?vue&type=template&id=6adacf5b"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6adacf5b&lang=css"
script.render = render

export default script